window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
if (typeof localStorage.getItem('user-token') != 'undefined') {
  const token = localStorage.getItem('user-token');
  window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
window.axios.defaults.baseURL = document.head.querySelector('[name=baseURL]').content;

window.axios.interceptors.response.use(
  function(config) {
    return config;
  },
  function(error) {
    if (error.response.status == 401) {
      localStorage.removeItem('user-token');
      delete window.axios.defaults.headers.common['Authorization'];
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);
